// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"799":"f60070c0","816":"dec4d00f","867":"79d014ea"}[chunkId] + ".js";
};